import {
  Button, Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  makeStyles, MenuItem, Select,
  Slide,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import {TransitionProps} from '@material-ui/core/transitions/transition';
import React, {useEffect, useRef, useState} from 'react';
import * as yup from 'yup';
import {Formik, FormikProps} from 'formik';
import Loading from "../../UiComponents/Loading";
import Group from "../../../Domain/Models/Group";
import {groupRepository} from "../../../Domain/Repositories/GroupRepository";
import {GameType} from "../../../Domain/Models/Cube";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  form: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  dialog: {
    alignItems: 'flex-start',
  },
  deleteFlex: {
    flex: 1,
  }
}));

export interface GroupModalProps
{
  open: boolean;
  onClose: () => void;
  group: Group;
}

export default function GroupModal(props: GroupModalProps)
{
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const { open, onClose, group } = props;
  const classes = useStyles();

  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState<string>();

  const formRef = useRef<FormikProps<Group>>(null);

  const schema = yup.object().shape({
  });

  const handleSubmit = (value: Group) =>
  {
    setSubmitting(true);
    setSubmitError(undefined);

    groupRepository.update(value)
      .then(() => onClose())
      .catch((e: Error) =>
      {
        setSubmitting(false);
        setSubmitError(e.message);
      });
  }

  useEffect(() =>
  {
    if (open)
    {
      setSubmitError(undefined);
      setSubmitting(false);
    }
  }, [open]);

  return (
    <Dialog
      classes={{scrollPaper: classes.dialog}}
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="md"
      disableEscapeKeyDown
      disableBackdropClick={submitting}
      TransitionComponent={Transition}
    >
      <DialogTitle>{`${group.playerPairs.map(x => x.name).join(' vs. ')}`}</DialogTitle>

      <Loading isLoading={submitting}>
        <DialogContent>
          <Formik<Group>
            initialValues={group}
            onSubmit={(value) => handleSubmit(value)}
            validationSchema={schema}
            innerRef={formRef}
          >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur
              }) => (
              <>
                <FormControl fullWidth margin="normal" error={touched.enableSubtitles && errors.enableSubtitles !== undefined}>
                  <InputLabel htmlFor="component-error">Subtitles</InputLabel>
                  <Select
                    name="enableSubtitles"
                    value={values.enableSubtitles}
                    onChange={handleChange}
                  >
                    <MenuItem value={true as any}>Enabled</MenuItem>
                    <MenuItem value={false as any}>Disabled</MenuItem>
                  </Select>
                  <FormHelperText>{touched.enableSubtitles && errors.enableSubtitles}</FormHelperText>
                </FormControl>
              </>
            )}
          </Formik>

          {submitError != undefined && (
            <Typography component="h3" variant="subtitle1" color="error" gutterBottom>
              {submitError}
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={onClose} color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => formRef.current?.handleSubmit()}
            color="primary"
          >
            Submit
          </Button>
        </DialogActions>

      </Loading>
    </Dialog>
  );
}